import RichTextField from './RichTextField';

export default RichTextField;
